import { ajaxErrorMessage } from "ajaxErrorMessage";
import $ from "jquery";
import * as localAPI from "localAPI";

let startedFetchingGoogleScript = false;
let loaded = false;
/** @type {((google: object) => void)[]} */
let loadedCallbacks = [];
let signInSuccessCallback: (() => void) | undefined;
let signInFailureCallback: (() => void) | undefined;

const doWhenLoaded = (callback) => {
  if (!startedFetchingGoogleScript) {
    $.getScript("https://accounts.google.com/gsi/client", () => {
      loaded = true;
      // @ts-ignore
      const google = window.google;

      google.accounts.id.initialize({
        client_id:
          // cspell: disable-next-line
          "600294213540-bfp4atl7c31mg86um6dcq2lvb635umom.apps.googleusercontent.com",
        callback: (response) => {
          // First make call to complete login to Readlang backend
          $.post("/api/auth/googleSignIn", {
            idToken: response.credential,
          })
            .done(
              // XXX Can't pass an async function here directly or it doesn't get called
              () =>
                (async () => {
                  if (signInSuccessCallback) {
                    signInSuccessCallback();
                  } else {
                    // Redirect or refresh
                    await localAPI.setLocalMode(false);
                    redirectOrReload();
                  }
                })()
            )
            .fail((jqXHR) => {
              alert(ajaxErrorMessage(jqXHR));
              signInFailureCallback?.();
            });
        },
      });

      for (const loadedCallback of loadedCallbacks) {
        // @ts-ignore
        loadedCallback(google);
      }
      loadedCallbacks = [];
    });
    startedFetchingGoogleScript = true;
  }

  if (loaded) {
    // @ts-ignore
    callback(window.google);
  } else {
    loadedCallbacks.push(callback);
  }
};

var redirectOrReload = () => {
  if (
    window.location.pathname === "/" ||
    window.location.pathname === "/login"
  ) {
    window.location.pathname = "/startSignedIn";
  } else {
    window.location.reload();
  }
};

export const signOut = () => {
  doWhenLoaded((google) => {
    google.accounts.id.disableAutoSelect();
  });
};

export const attachSignInClickHandler = (
  container,
  _options?: object,
  successCallback?: () => void,
  failureCallback?: () => void
) => {
  signInSuccessCallback = successCallback;
  signInFailureCallback = failureCallback;

  doWhenLoaded((google) => {
    google.accounts.id.renderButton(container, {
      theme: "filled_blue",
      size: "large",
      // Matches "Continue with Apple", and suits signing up as well as in
      text: "continue_with",
      width: `${Math.floor($(container).width())}`,
      locale: "en",
    });
  });
};
